export const GET_SUPPORTS = 'GET_SUPPORTS';
export const SET_SUPPORTS = 'SET_SUPPORTS';
export const SET_SUPPORT = 'SET_SUPPORT';
export const GET_SUPPORT = 'GET_SUPPORT';
export const SET_SUPPORTS_STATE = 'SET_SUPPORTS_STATE';
export const DELETE_SUPPORT = 'DELETE_SUPPORT';
export const SET_REVIEWS = 'SET_REVIEWS';
export const GET_REVIEWS = 'GET_REVIEWS';
export const GET_REVIEW = 'GET_REVIEW';
export const SET_REVIEW = 'SET_REVIEW';